import { Injectable } from 'angular-ts-decorators';
import { User, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

@Injectable('AuthService')
export class AuthService {
    userManager: UserManager;
/*
    authority: 'https://auth.seasonticker.localhost/oidc',
    //autoSignIn: false,
    client_id: 'seasonticker',
    loadUserInfo: true,
    //location: location,
    redirect_uri: `${window.location.protocol}//${window.location.hostname}`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}`,
    scope: 'openid email profile',
    automaticSilentRenew: true,
    response_type: 'code',
    response_mode: 'fragment',
    onSigninCallback: onSignIn,
    onRemoveUser: onSignOut,
*/
  constructor() {
    const settings = {
      authority: process.env.VITE_APP_SSO_AUTHORITY, //'https://auth.seasonticker.localhost/oidc',
      client_id: 'seasonticker',
      redirect_uri: `${window.location.protocol}//${window.location.hostname}`,
      post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}`,
      response_type: 'code',
      response_mode: 'fragment',
      scope: 'openid email profile',
      userStore: new WebStorageStateStore( { store: localStorage })
    } as UserManagerSettings;
    this.userManager = new UserManager(settings);
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public renewToken(): Promise<User | null> {
    return this.userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }
}
